import {
  Activity,
  BarChart3,
  BookOpen,
  CalendarDays,
  CalendarCheck2,
  ClipboardCheck,
  Headphones,
  Gem,
  LayoutDashboard,
  Settings,
  UserCheck,
  Users,
  Video,
} from "lucide-react";

export const ADMIN_NAVIGATION = [
  { to: "/yonetim", label: "Genel Bakış", icon: LayoutDashboard, end: true, testid: "nav-dashboard", module: "dashboard" },
  { to: "/yonetim/danisanlar", label: "Danışanlar ve Davetler", crumb: "Danışanlar", icon: Users, testid: "nav-clients", module: "clients" },
  { to: "/yonetim/program-talepleri", label: "Program Talepleri", icon: ClipboardCheck, module: "clients", adminOnly: true, testid: "nav-program-requests" },
  { to: "/yonetim/operasyon-kuyrugu", label: "Operasyon Kuyruğu", icon: Activity, module: "dashboard", adminOnly: true, testid: "nav-operations" },
  { to: "/yonetim/istatistikler", label: "İstatistikler", icon: BarChart3, module: "dashboard", adminOnly: true, testid: "nav-analytics" },
  { to: "/yonetim/yeni-deneyimler", label: "Yeni Deneyimler", icon: BookOpen, testid: "nav-new-experiences", module: "clients", adminOnly: true, badge: "experiences" },
  { to: "/yonetim/uygulayici-onaylari", label: "Uygulayıcı Onayları", icon: UserCheck, testid: "nav-practitioner-approvals", module: "clients", adminOnly: true, badge: "practitioners" },
  { to: "/yonetim/ses-kutuphanesi", label: "Ses İçerikleri", icon: Headphones, module: "clients", adminOnly: true },
  { to: "/yonetim/video-kutuphanesi", label: "Video İçerikleri", icon: Video, module: "clients", adminOnly: true },
  { to: "/yonetim/konular", label: "Konular ve Makaleler", icon: BookOpen, module: "clients", adminOnly: true },
  { to: "/yonetim/uzaktan-seanslar", label: "Uzaktan Seanslar", icon: CalendarCheck2, module: "clients", adminOnly: true },
  { to: "/yonetim/dogal-tas-setleri", label: "Doğal Taş Setleri", icon: Gem, module: "clients", adminOnly: true },
  { to: "/yonetim/program-yonetimi", label: "Program Kataloğu", icon: CalendarDays, module: "clients", adminOnly: true },
  { to: "/yonetim/ayarlar", label: "Ayarlar", icon: Settings, testid: "nav-settings", module: "settings", adminOnly: true },
];

export const ADMIN_CRUMBS = Object.fromEntries(
  ADMIN_NAVIGATION.map((item) => [item.to, item.crumb || item.label]),
);
